<ion-header>
  <ion-toolbar>
    <ion-title> </ion-title>
    <ion-buttons slot="end">
      <app-modal-back icon="close"></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-margin-top">
    <mable-heading
      heading="h2"
      headingStyle="h1"
    >
      Evaluate later?
    </mable-heading>
  </div>
  <div class="ion-margin-horizontal">
    <p>You can evaluate {{workerName}} later from your dashboard.</p>
    <p>Your anonymous input helps your support worker using Mable improve their services and reliability.</p>
    <p>You can also opt-out of regular evaluations.</p>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            expand="block"
            (onClick)="modalCtrl.dismiss({doItLater:true})"
          >
            Do it later
          </mable-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            expand="block"
            category="outline"
            (onClick)="modalCtrl.dismiss()"
          >
            Back
          </mable-button>
        </ion-col>
        <ion-col>
          <mable-button
            class="ion-no-margin"
            expand="block"
            category="outline"
            (onClick)="optOut()"
          >
            Opt-out
          </mable-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
